import { useCallback, useContext } from 'react'
import {
  type AdvanceSelectionAwayFromFn,
  InboxArchiveAdvanceContext,
} from '#src/contexts/InboxArchiveAdvanceContext.ts'

/*
 * Returns the sidebar's "advance ?selected= away from this key" callback.
 * Falls back to a no-op when used outside an InboxArchiveAdvanceContext
 * provider (e.g. in storybook or non-inbox contexts), so InboxRow can call
 * it unconditionally without checking for a provider.
 */
export function useInboxArchiveAdvance(): AdvanceSelectionAwayFromFn {
  const advance = useContext(InboxArchiveAdvanceContext)
  return useCallback(
    (key: string) => {
      advance?.(key)
    },
    [advance]
  )
}
